import React, { useState, useEffect, useCallback } from 'react';
import URLManager from '../funcionalidadeNavbar/URLManager';
import CompraFormulario from './CompraFormulario';
import CompraTabela from './CompraTabela';
import CompraDetalhes from './CompraDetalhes';
import ConfirmationModal from '../components/ConfirmationModal';
import { Snackbar } from '@mui/material';
import './Compra.css';

const Compra = () => {
  const _url = URLManager.getBaseURL();
  const [compras, setCompras] = useState([]);
  const [compraEditando, setCompraEditando] = useState(null);
  const [compraSelecionada, setCompraSelecionada] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [filtroStatus, setFiltroStatus] = useState('TODAS');
  const [apenasAutomaticas, setApenasAutomaticas] = useState(false);
  const [comprasSelecionadas, setComprasSelecionadas] = useState([]);
  const [modalConfirmacao, setModalConfirmacao] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');

  const listarCompras = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const token = sessionStorage.getItem('usuarioToken');
      // Se houver filtro por status, utilizar endpoint específico
      const url = filtroStatus && filtroStatus !== 'TODAS'
        ? `${_url}/compra/listar/status/${filtroStatus}`
        : `${_url}/compra/listar`;
      const response = await fetch(url, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('Erro ao listar compras');
      }

      const data = await response.json();
      // Aplicar filtro local para automáticas, se marcado
      const filtradas = apenasAutomaticas ? (data || []).filter(c => c.geradoAutomaticamente) : data;
      setCompras(filtradas);
    } catch (err) {
      setError(err.message);
      console.error('Erro ao carregar compras:', err);
    } finally {
      setLoading(false);
    }
  }, [filtroStatus, apenasAutomaticas, _url]);

  useEffect(() => {
    listarCompras();
  }, [listarCompras]);

  const handleSalvar = async (compraData) => {
    try {
      const token = sessionStorage.getItem('usuarioToken');
      const url = `${_url}/compra/criar`;
      
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(compraData)
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || 'Erro ao salvar compra');
      }

      await listarCompras();
      setCompraEditando(null);
      alert('Compra salva com sucesso!');
    } catch (err) {
      alert(`Erro: ${err.message}`);
      console.error('Erro ao salvar compra:', err);
    }
  };

  const handleEditar = (compra) => {
    setCompraEditando(compra);
  };

  const handleCancelar = () => {
    setCompraEditando(null);
  };

  const handleDeletar = async (id) => {
    if (!window.confirm('Deseja realmente deletar esta compra?')) {
      return;
    }

    try {
      const token = sessionStorage.getItem('usuarioToken');
      const response = await fetch(`${_url}/compra/${id}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || 'Erro ao deletar compra');
      }

      await listarCompras();
      alert('Compra deletada com sucesso!');
    } catch (err) {
      alert(`Erro: ${err.message}`);
      console.error('Erro ao deletar compra:', err);
    }
  };

  const handleAprovar = async (id) => {
    try {
      const token = sessionStorage.getItem('usuarioToken');
      const response = await fetch(`${_url}/compra/${id}/aprovar`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || 'Erro ao aprovar compra');
      }

      await listarCompras();
      alert('Compra aprovada com sucesso!');
    } catch (err) {
      alert(`Erro: ${err.message}`);
      console.error('Erro ao aprovar compra:', err);
    }
  };

  const handleReceber = async (id) => {
    try {
      const token = sessionStorage.getItem('usuarioToken');
      const response = await fetch(`${_url}/compra/${id}/receber`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || 'Erro ao receber compra');
      }

      await listarCompras();
      alert('Compra recebida com sucesso! Estoque atualizado.');
    } catch (err) {
      alert(`Erro: ${err.message}`);
      console.error('Erro ao receber compra:', err);
    }
  };

  const handleCancelarCompra = async (id) => {
    if (!window.confirm('Deseja realmente cancelar esta compra?')) {
      return;
    }

    try {
      const token = sessionStorage.getItem('usuarioToken');
      const response = await fetch(`${_url}/compra/${id}/cancelar`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || 'Erro ao cancelar compra');
      }

      await listarCompras();
      alert('Compra cancelada com sucesso!');
    } catch (err) {
      alert(`Erro: ${err.message}`);
      console.error('Erro ao cancelar compra:', err);
    }
  };

  const handleDetalhes = (compra) => {
    setCompraSelecionada(compra);
  };

  const handleFecharDetalhes = () => {
    setCompraSelecionada(null);
  };

  const handleSelecionarCompra = (id) => {
    setComprasSelecionadas((prev) => {
      if (prev.includes(id)) {
        return prev.filter((compraId) => compraId !== id);
      } else {
        return [...prev, id];
      }
    });
  };

  const handleSelecionarTodas = () => {
    if (comprasSelecionadas.length === compras.length) {
      setComprasSelecionadas([]);
    } else {
      setComprasSelecionadas(compras.map((c) => c.id));
    }
  };

  const handleDeletarMultiplas = () => {
    if (comprasSelecionadas.length === 0) {
      setSnackbarMessage('Selecione pelo menos uma compra para deletar');
      setSnackbarOpen(true);
      return;
    }
    setModalConfirmacao(true);
  };

  const handleConfirmarDelete = async () => {
    setModalConfirmacao(false);
    try {
      const token = sessionStorage.getItem('usuarioToken');
      const response = await fetch(`${_url}/compra/deletar-multiplos`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(comprasSelecionadas)
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || 'Erro ao deletar compras');
      }

      setComprasSelecionadas([]);
      await listarCompras();
      setSnackbarMessage('Items deletados com sucesso');
      setSnackbarOpen(true);
    } catch (err) {
      setSnackbarMessage(`Erro: ${err.message}`);
      setSnackbarOpen(true);
      console.error('Erro ao deletar múltiplas compras:', err);
    }
  };

  // Calcular soma dos valores em aberto
  const calcularValorEmAberto = () => {
    return (compras || [])
      .filter(compra => compra.status !== 'RECEBIDA' && compra.status !== 'CANCELADA')
      .reduce((total, compra) => total + (compra.valorTotal || 0), 0);
  };

  const valorEmAberto = calcularValorEmAberto();

  return (
    <div className="compra-container">
      <div className="compra-header">
        <h2>Gestão de Compras</h2>
        {!compraEditando && (
          <button 
            className="btn-nova-compra"
            onClick={() => setCompraEditando({})}
          >
            + Nova Compra
          </button>
        )}
      </div>

      {/* Barra de filtros */}
      {!compraEditando && (
        <div className="compra-filtros">
          <div className="filtro-item">
            <label>Status</label>
            <select value={filtroStatus} onChange={(e) => setFiltroStatus(e.target.value)}>
              <option value="TODAS">Todas</option>
              <option value="ABERTA">Aberta</option>
              <option value="APROVADA">Aprovada</option>
              <option value="RECEBIDA">Recebida</option>
              <option value="CANCELADA">Cancelada</option>
            </select>
          </div>
          <div className="filtro-item checkbox">
            <label>
              <input
                type="checkbox"
                checked={apenasAutomaticas}
                onChange={(e) => {
                  setApenasAutomaticas(e.target.checked);
                  // refiltra rapidamente sem nova chamada (aplica sobre compras já carregadas)
                  if (e.target.checked) {
                    setCompras((prev) => (prev || []).filter(c => c.geradoAutomaticamente));
                  } else {
                    // recarregar com o mesmo status
                    listarCompras();
                  }
                }}
              />
              Mostrar apenas automáticas
            </label>
          </div>
        </div>
      )}

      {/* Card com Valor em Aberto */}
      {!compraEditando && (
        <div className="valor-em-aberto-card">
          <div className="valor-em-aberto-content">
            <div className="valor-em-aberto-label">Valor em Aberto</div>
            <div className="valor-em-aberto-valor">
              R$ {valorEmAberto.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.')}
            </div>
            <div className="valor-em-aberto-descricao">
              (Compras ABERTA e APROVADA)
            </div>
          </div>
        </div>
      )}

      {error && (
        <div className="alert alert-danger">
          {error}
        </div>
      )}

      {compraEditando !== null ? (
        <CompraFormulario
          compra={compraEditando}
          onSalvar={handleSalvar}
          onCancelar={handleCancelar}
        />
      ) : (
        <>
          {comprasSelecionadas.length > 0 && (
            <div className="toolbar-acoes-multiplas">
              <span>{comprasSelecionadas.length} compra(s) selecionada(s)</span>
              <button 
                className="btn-deletar-multiplas"
                onClick={handleDeletarMultiplas}
              >
                🗑 Deletar Selecionadas
              </button>
            </div>
          )}
          <CompraTabela
            compras={compras}
            loading={loading}
            onEditar={handleEditar}
            onDeletar={handleDeletar}
            onAprovar={handleAprovar}
            onReceber={handleReceber}
            onCancelar={handleCancelarCompra}
            onDetalhes={handleDetalhes}
            comprasSelecionadas={comprasSelecionadas}
            onSelecionarCompra={handleSelecionarCompra}
            onSelecionarTodas={handleSelecionarTodas}
          />
        </>
      )}

      {compraSelecionada && (
        <CompraDetalhes 
          compra={compraSelecionada} 
          onFechar={handleFecharDetalhes}
        />
      )}

      <ConfirmationModal
        open={modalConfirmacao}
        title="Deletar Compra(s)"
        message={`Deseja realmente deletar ${comprasSelecionadas.length} compra(s)?`}
        type="warning"
        confirmText="Deletar"
        cancelText="Cancelar"
        onConfirm={handleConfirmarDelete}
        onCancel={() => setModalConfirmacao(false)}
        confirmButtonColor="error"
      />

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      />
    </div>
  );
};

export default Compra;
